export class repeatNav {
  constructor(difference) {
    this.width = 320
    this.height = 300
    this.top = 20
    this.left = 20
    this.innerElement = "cxRepeatNav"
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.mode = "vertical" //horizontal / vertical
    this.showColNumber = 10 //显示列数
    this.widthList = [25,25,25,25]
    this.changeWay = "scroll" // 切换方式
    this.bgColor = "#fff"
    this.bgIsThemeColor = false
    this.value = ""
    this.opacity = 100
    this.background = []
    this.selectOptions = [
      {
        label: "菜单1",
        value: "",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/",
                children: [
                  {
                    label: "选项1",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项2",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项3",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项4",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项5",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项6",
                    value: "https://www.chaoxing.com/"
                  },
                  {
                    label: "选项7",
                    value: "https://www.chaoxing.com/"
                  }
                ]
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/",
            children: [
              {
                label: "选项1",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项2",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项3",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项4",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项5",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项6",
                value: "https://www.chaoxing.com/"
              },
              {
                label: "选项7",
                value: "https://www.chaoxing.com/"
              }
            ]
          }
        ]
      },
      {
        label: "菜单2",
        value: "http://www.baidu.com",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/"
          }
        ]
      },
      {
        label: "菜单3",
        value: "http://www.baidu.com",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项3",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项4",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项5",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项6",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项7",
            value: "https://www.chaoxing.com/"
          }
        ]
      },
      {
        label: "菜单4",
        value: "",
        children: [
          {
            label: "选项1",
            value: "https://www.chaoxing.com/"
          },
          {
            label: "选项2",
            value: "https://www.chaoxing.com/"
          },
        ]
      }
    ]
    
    // 阴影
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]

    this.widthAuto = true // 宽度 平均和自定义
    this.navWidth = 106
    this.lineMargin = 0 //行间距
    this.columnMargin = 0 //列间距

    this.buttonIconClassName = "icon-portal-arrow1"
    this.buttonIconSize = 20
    this.buttonIconColor = "rgba(0, 0, 0, 0.8)"
    this.buttonIconShowBackGround = true
    this.buttonIconBackgroundColor = "rgba(0, 0, 0, 0)"
    this.buttonIconBackgroundWidth = 32
    this.buttonIconBackgroundHeight = 32
    this.buttonIconBackGroundBorderRadius = 0
    this.buttonIconCustomTop = false
    this.buttonIconPadding = 20
    this.buttonIconTop = 20
    this.buttonIconSrc = "FCDE54BF21DDAE3D"
    this.buttonIconColorIsThemeColor = false
    this.buttonIconBgIsThemeColor = false

    this.borderTypeFlag = 2
    this.borderRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderTopRightRadius = 0
    this.borderTopLeftRadius = 0
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 30
    this.paddingLeft = 30
    this.paddingBottom = 0
    this.paddingTypeFlag = 2
    this.borderWidth = 0
    this.borderColor = "#3D82F2"
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    // 一级菜单默认样式
    this.fontFamily = "sans-serif"
    this.fontSize = 16
    this.fontWeight = "600"
    this.fontStyle = "normal"
    this.textDecoration = "none"
    this.lineHeight = 36
    this.letterSpacing = 0
    this.writingMode = "horizontal-tb"
    this.textAlign = "left"
    this.textIsThemeColor = false
    this.color = "rgba(0,0,0,0.8)"
    this.topNavTextLimit = true // 一级菜单字数限制
    this.topNavTextLimitCount = 4
    this.topNavBackground = []
    this.topNavBgColor = "#fff"
    this.topNavBgColorIsThemeColor = false
    this.topNavBorderWidth = 0
    this.topNavBorderColor = "#3D82F2"
    this.topNavBorderStyle = "solid" // solid, dashed, dotted
    this.topNavBorderIsThemeColor = false
    this.topNavBoxShadowColor = ["rgba(255,255,255,1)"]
    this.topNavBoxShadowH = [0]
    this.topNavBoxShadowV = [0]
    this.topNavBoxShadowBlur = [0]
    this.topNavBoxShadowSpread = [0]
    this.topNavBorderTypeFlag = 2
    this.topNavBorderRadius = 0
    this.topNavBorderBottomLeftRadius = 0
    this.topNavBorderBottomRightRadius = 0
    this.topNavBorderTopRightRadius = 0
    this.topNavBorderTopLeftRadius = 0
    this.topNavPadding = 0
    this.topNavPaddingTop = 0
    this.topNavPaddingRight = 20
    this.topNavPaddingLeft = 20
    this.topNavPaddingBottom = 0
    this.topNavPaddingTypeFlag = 2
    this.showTopNavIcon = false
    this.iconPosition = "right" // left,right
    this.iconSrc = "5CB4CFFC9CE56FF2"
    this.iconType = "icon" // img,icon 图片和字体图标
    this.iconWidth = 14
    this.iconMargin = 10
    this.iconColorIsThemeColor = false
    this.iconColor = "rgba(0,0,0,0.4)"

    // 二级菜单默认样式
    this.liTextLimit = true // 二级菜单字数限制
    this.liTextLimitCount = 4
    this.liPadding = 0
    this.liPaddingTop = 0
    this.liPaddingRight = 20
    this.liPaddingLeft = 20
    this.liPaddingBottom = 0
    this.liPaddingTypeFlag = 2
    this.showLiNavIcon = false
    this.liIconPosition = "right" // left,right
    this.liIconSrc = ""
    this.liIconType = "icon" // img,icon 图片和字体图标
    this.liIconWidth = 14
    this.liIconMargin = 10
    this.liIconColorIsThemeColor = false
    this.liIconColor = "rgba(0,0,0,0.4)"
    this.liBgColor = "#fff"
    this.liBgIsThemeColor = false
    this.liHeight = 40 // 下拉列表项高度
    this.liWidth = 160 // 下拉列表项高度
    this.liBorderWidth = 0
    this.liBorderColor = "#3D82F2"
    this.liBorderStyle = "solid" // solid, dashed, dotted
    this.liBorderIsThemeColor = false
    this.liFontFamily = "sans-serif"
    this.liFontSize = 16
    this.liFontWeight = "400"
    this.liFontColor = "rgba(0,0,0,0.8)"
    this.liIsThemeColor = false
    this.liLetterSpacing = 0
    this.liFontStyle = "normal"
    this.liTextAlign = "left"
    this.liWritingMode = "horizontal-tb"
    this.liTextDecoration = "none"
    this.liTextIndent = 0
    this.liLineHeight = 36

    this.liBackground = []
    this.liBgColor = "#fff"
    this.liBgColorIsThemeColor = false

    this.liBoxShadowColor = ["rgba(255,255,255,1)"] // 二级菜单的阴影
    this.liBoxShadowH = [0]
    this.liBoxShadowV = [0]
    this.liBoxShadowBlur = [0]
    this.liBoxShadowSpread = [0]
    this.liBorderTypeFlag = 2
    this.liBorderRadius = 0
    this.liBorderBottomLeftRadius = 0
    this.liBorderBottomRightRadius = 0
    this.liBorderTopRightRadius = 0
    this.liBorderTopLeftRadius = 0

    // 更多按钮默认样式
    this.moreContent = "更多"
    this.moreTextLimit = true
    this.moreTextLimitCount = 4
    this.morePadding = 0
    this.morePaddingTop = 0
    this.morePaddingRight = 20
    this.morePaddingLeft = 20
    this.morePaddingBottom = 0
    this.morePaddingTypeFlag = 2
    this.showMoreNavIcon = false
    this.moreIconPosition = "right" // left,right
    this.moreIconSrc = ""
    this.moreIconType = "icon" // img,icon 图片和字体图标
    this.moreIconWidth = 14
    this.moreIconMargin = 10
    this.moreIconColorIsThemeColor = false
    this.moreIconColor = "rgba(0,0,0,0.4)"
    this.moreBgColor = "#fff"
    this.moreBgIsThemeColor = false
    this.moreHeight = 40
    this.moreWidth = 160
    this.moreBorderWidth = 0
    this.moreBorderColor = "#3D82F2"
    this.moreBorderStyle = "solid" // solid, dashed, dotted
    this.moreBorderIsThemeColor = false
    this.moreFontFamily = "sans-serif"
    this.moreFontSize = 16
    this.moreFontWeight = "400"
    this.moreFontColor = "rgba(0,0,0,0.8)"
    this.moreIsThemeColor = false
    this.moreLetterSpacing = 0
    this.moreFontStyle = "normal"
    this.moreTextAlign = "left"
    this.moreWritingMode = "horizontal-tb"
    this.moreTextDecoration = "none"
    this.moreTextIndent = 0
    this.moreLineHeight = 36

    this.moreBackground = []
    this.moreBgColor = "#fff"
    this.moreBgColorIsThemeColor = false

    this.moreBoxShadowColor = ["rgba(255,255,255,1)"]
    this.moreBoxShadowH = [0]
    this.moreBoxShadowV = [0]
    this.moreBoxShadowBlur = [0]
    this.moreBoxShadowSpread = [0]
    this.moreBorderTypeFlag = 2
    this.moreBorderRadius = 0
    this.moreBorderBottomLeftRadius = 0
    this.moreBorderBottomRightRadius = 0
    this.moreBorderTopRightRadius = 0
    this.moreBorderTopLeftRadius = 0

    // 一级菜单选中悬浮样式
    this.activeFontFamily = "sans-serif"
    this.activeFontSize = 16
    this.activeFontWeight = "600"
    this.activeFontColor = "rgba(0, 0, 0, 0.8)"
    this.activeTextIsThemeColor = true
    this.activeLetterSpacing = 0
    this.activeFontStyle = "normal"
    this.activeTextAlign = "left"
    this.activeWritingMode = "horizontal-tb"
    this.activeTextDecoration = "none"
    this.activeTextIndent = 0
    this.activeLineHeight = 36
    this.activeBgColor = "#F0F2F7"
    this.activeBgIsThemeColor = false
    this.activeBorderWidth = 0
    this.activeBorderColor = "#3D82F2"
    this.activeBorderStyle = "solid" // solid, dashed, dotted
    this.activeBorderIsThemeColor = false
    this.activeTextIsThemeColor = false
    this.activeColor = "rgba(0,0,0,0.8)"
    this.activeTopNavTextLimit = true // 一级菜单字数限制
    this.activeTopNavTextLimitCount = 4
    this.activeTopNavBackground = []
    this.activeTopNavBgColor = "#fff"
    this.activeTopNavBgColorIsThemeColor = false
    this.activeTopNavBorderWidth = 0
    this.activeTopNavBorderColor = "#3D82F2"
    this.activeTopNavBorderStyle = "solid" // solid, dashed, dotted
    this.activeTopNavBorderIsThemeColor = false
    this.activeTopNavBoxShadowColor = ["rgba(255,255,255,1)"]
    this.activeTopNavBoxShadowH = [0]
    this.activeTopNavBoxShadowV = [0]
    this.activeTopNavBoxShadowBlur = [0]
    this.activeTopNavBoxShadowSpread = [0]
    this.activeTopNavBorderTypeFlag = 2
    this.activeTopNavBorderRadius = 0
    this.activeTopNavBorderBottomLeftRadius = 0
    this.activeTopNavBorderBottomRightRadius = 0
    this.activeTopNavBorderTopRightRadius = 0
    this.activeTopNavBorderTopLeftRadius = 0
    this.activeTopNavPadding = 0
    this.activeTopNavPaddingTop = 0
    this.activeTopNavPaddingRight = 20
    this.activeTopNavPaddingLeft = 20
    this.activeTopNavPaddingBottom = 0
    this.activeTopNavPaddingTypeFlag = 2
    this.activeShowTopNavIcon = false
    this.activeIconPosition = "right" // left,right
    this.activeIconSrc = "5CB4CFFC9CE56FF2"
    this.activeIconType = "icon" // img,icon 图片和字体图标
    this.activeIconWidth = 14
    this.activeIconMargin = 10
    this.activeIconColorIsThemeColor = false
    this.activeIconColor = "rgba(0,0,0,0.4)"

    // 二级菜单选中悬浮样式
    this.liActiveTextLimit = true // 二级菜单字数限制
    this.liActiveTextLimitCount = 4
    this.liActivePadding = 0
    this.liActivePaddingTop = 0
    this.liActivePaddingRight = 20
    this.liActivePaddingLeft = 20
    this.liActivePaddingBottom = 0
    this.liActivePaddingTypeFlag = 2
    this.liActiveNavIcon = false
    this.liActiveIconPosition = "right" // left,right
    this.liActiveIconSrc = ""
    this.liActiveIconType = "icon" // img,icon 图片和字体图标
    this.liActiveIconWidth = 14
    this.liActiveIconMargin = 10
    this.liActiveIconColorIsThemeColor = false
    this.liActiveIconColor = "rgba(0,0,0,0.4)"
    this.liActiveBgColor = "#fff"
    this.liActiveBgIsThemeColor = false
    this.liActiveHeight = 40 // 下拉列表项高度
    this.liActiveWidth = 160 // 下拉列表项高度
    this.liActiveBorderWidth = 0
    this.liActiveBorderColor = "#3D82F2"
    this.liActiveBorderStyle = "solid" // solid, dashed, dotted
    this.liActiveBorderIsThemeColor = false
    this.liActiveFontFamily = "sans-serif"
    this.liActiveFontSize = 16
    this.liActiveFontWeight = "400"
    this.liActiveFontColor = "rgba(0,0,0,0.8)"
    this.liActiveIsThemeColor = false
    this.liActiveLetterSpacing = 0
    this.liActiveFontStyle = "normal"
    this.liActiveTextAlign = "left"
    this.liActiveWritingMode = "horizontal-tb"
    this.liActiveTextDecoration = "none"
    this.liActiveTextIndent = 0
    this.liActiveLineHeight = 36

    this.liActiveBackground = []
    this.liActiveBgColor = "#fff"
    this.liActiveBgColorIsThemeColor = false

    this.liActiveBoxShadowColor = ["rgba(255,255,255,1)"] // 二级菜单的阴影
    this.liActiveBoxShadowH = [0]
    this.liActiveBoxShadowV = [0]
    this.liActiveBoxShadowBlur = [0]
    this.liActiveBoxShadowSpread = [0]

    this.liActiveBorderTypeFlag = 2
    this.liActiveBorderRadius = 0
    this.liActiveBorderBottomLeftRadius = 0
    this.liActiveBorderBottomRightRadius = 0
    this.liActiveBorderTopRightRadius = 0
    this.liActiveBorderTopLeftRadius = 0

    // 更多按钮选中悬浮样式
    this.moreActiveTextLimit = true
    this.moreActiveTextLimitCount = 4
    this.moreActivePadding = 0
    this.moreActivePaddingTop = 0
    this.moreActivePaddingRight = 20
    this.moreActivePaddingLeft = 20
    this.moreActivePaddingBottom = 0
    this.moreActivePaddingTypeFlag = 2
    this.showMoreActiveNavIcon = false
    this.moreActiveIconPosition = "right" // left,right
    this.moreActiveIconSrc = ""
    this.moreActiveIconType = "icon" // img,icon 图片和字体图标
    this.moreActiveIconWidth = 14
    this.moreActiveIconMargin = 10
    this.moreActiveIconColorIsThemeColor = false
    this.moreActiveIconColor = "rgba(0,0,0,0.4)"
    this.moreActiveBgColor = "#fff"
    this.moreActiveBgIsThemeColor = false
    this.moreActiveHeight = 40
    this.moreActiveWidth = 160
    this.moreActiveBorderWidth = 0
    this.moreActiveBorderColor = "#3D82F2"
    this.moreActiveBorderStyle = "solid" // solid, dashed, dotted
    this.moreActiveBorderIsThemeColor = false
    this.moreActiveFontFamily = "sans-serif"
    this.moreActiveFontSize = 16
    this.moreActiveFontWeight = "400"
    this.moreActiveFontColor = "rgba(0,0,0,0.8)"
    this.moreActiveIsThemeColor = false
    this.moreActiveLetterSpacing = 0
    this.moreActiveFontStyle = "normal"
    this.moreActiveTextAlign = "left"
    this.moreActiveWritingMode = "horizontal-tb"
    this.moreActiveTextDecoration = "none"
    this.moreActiveTextIndent = 0
    this.moreActiveLineHeight = 36

    this.moreActiveBackground = []
    this.moreActiveBgColor = "#fff"
    this.moreActiveBgColorIsThemeColor = false

    this.moreActiveBoxShadowColor = ["rgba(255,255,255,1)"]
    this.moreActiveBoxShadowH = [0]
    this.moreActiveBoxShadowV = [0]
    this.moreActiveBoxShadowBlur = [0]
    this.moreActiveBoxShadowSpread = [0]
    this.moreActiveBorderTypeFlag = 2
    this.moreActiveBorderRadius = 0
    this.moreActiveBorderBottomLeftRadius = 0
    this.moreActiveBorderBottomRightRadius = 0
    this.moreActiveBorderTopRightRadius = 0
    this.moreActiveBorderTopLeftRadius = 0

    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.openBlankPage = true
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
